import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import Sectors from "@/pages/Sectors";
import CiergeLabs from "@/pages/CiergeLabs";
import Evidence from "@/pages/Evidence";
import Company from "@/pages/Company";
import TechnicalAppendix from "@/pages/TechnicalAppendix";
import Foundation from "@/pages/Foundation";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/engineering-architecture" element={<Platform />} />
            <Route path="/platform" element={<Navigate to="/engineering-architecture" replace />} />
            <Route path="/sectors" element={<Sectors />} />
            <Route path="/cierge-studio" element={<CiergeLabs />} />
            <Route path="/evidence" element={<Evidence />} />
            <Route path="/company" element={<Company />} />
            <Route path="/technical-appendix" element={<TechnicalAppendix />} />
          </Route>
          {/* Internal review route — excluded from public nav, search and sitemap. */}
          <Route path="/foundation" element={<Foundation />} />
        </Routes>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
